import { useRef, useEffect } from 'react'

function createRootElement(id) {
  const rootContainer = document.createElement('div')
  rootContainer.setAttribute('id', id)
  return rootContainer
}

function addRootElement(rootElem) {
  if (!document.body.lastElementChild) {
    document.body.appendChild(document.createElement('div'))
  }
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling)
}

function usePortal(id, className) {
  const rootElemRef = useRef(null)

  useEffect(
    function setupElement() {
      const existingParent = document.querySelector(`#${id}`)
      const parentElem = existingParent || createRootElement(id)

      if (!existingParent) {
        addRootElement(parentElem)
      }

      if (className) {
        getRootElem().className = className
      }

      parentElem.appendChild(getRootElem())

      return function removeElement() {
        rootElemRef.current.remove()
      }
    },
    [id, className]
  )

  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div')
    }
    return rootElemRef.current
  }

  return getRootElem()
}

export default usePortal
